<script context="module" lang="ts">
	import Policy from './policy.svelte';
	import Spinner from '$lib/components/Spinner.svelte';
	import icoAdd from 'iconoir/icons/plus-circle.svg';

	import { apiUrl } from '$lib/settings/api';

	export async function loadPolicies() {
		const url = apiUrl + 'policies/policies';
		const res = await fetch(url);
		let posts = res.json();
		return posts;
	}

	import getPermissions from '../auth/getPermissions';

	async function canCreate() {
		return await getPermissions('create-policy');
	}
</script>

<script lang="ts">
</script>

{#await canCreate()}
	<div />
{:then result}
	{#if result == true}
		<div class="">
			<a href="/policies/create/"><img class="float-right w-6" src={icoAdd} alt="Add Policy" /></a>
		</div>
		<div class="clear-right mb-2" />
	{/if}
{/await}

<div>
	{#await loadPolicies()}
		<Spinner />
	{:then policies}
		{#if policies.length == 0}
			<div class="rounded-md bg-white p-2 pb-4 drop-shadow-sm">
				<p class="text-center text-lg font-medium">No Policies Currently</p>
				<p class="pt-4 text-center">
					Check back later to see all our current policies. For family, student & class policies -
					please visit the customer portal.
				</p>
			</div>
		{/if}
		{#each policies as policy}
			<a href={'/policies/' + policy._id}>
				<Policy
					policyId={policy._id}
					policyName={policy.policyName}
					policyBody=""
					policyUpdated={policy.policyUpdated}
				/>
			</a>
			<br />
		{/each}
	{/await}
</div>
